import React, { useState, useRef } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";


const UploadQRCode2 = () => {

  const fileInputRef = useRef(null);

  const [imageUrl, setImageUrl] = useState("");
  const [redirecting, setRedirecting] = useState(false);
  const [error, setError] = useState("");



  const styles = {


    container: {

      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      marginTop: "20px",

    },


    button: {

      backgroundColor: "#2563eb",

      color: "white",

      padding: "12px 30px",

      borderRadius: "10px",

      border: "none",

      fontSize: "16px",

      fontWeight: "bold",

      cursor: "pointer",

    },


    qrImage: {

      width: "220px",

      marginTop: "20px",

      borderRadius: "10px",

    },


    success: {

      marginTop:"20px",

      display:"flex",

      flexDirection:"column",

      alignItems:"center",

    },


    successText: {

      color:"green",

      fontSize:"20px",

      fontWeight:"bold",

      marginTop:"10px",

    },


    redirectText: {

      color:"green",

    },


    error: {

      color:"red",

      marginTop:"15px",

      fontWeight:"bold",

    }


  };







  const handleUploadButton = () => {

    fileInputRef.current.click();

  };







  const handleImageUpload = (event) => {


    const file = event.target.files[0];


    if (!file) return;



    const reader = new FileReader();



    reader.onload = () => {


      setImageUrl(reader.result);


      decodeQR(reader.result);


    };



    reader.readAsDataURL(file);


  };








  const decodeQR = async (imageSrc) => {


    setError("");

    setRedirecting(false);



    const image = new Image();


    image.src = imageSrc;



    image.onload = async () => {


      const codeReader = new BrowserMultiFormatReader();



      try {


        const result =
          await codeReader.decodeFromImageElement(image);



        const qrText = result.text;



        if (

          qrText.startsWith("http://") ||

          qrText.startsWith("https://")

        ) {



          setRedirecting(true);



          setTimeout(() => {


            window.location.href = qrText;


          }, 2000);



        }
        else {


          setError(
            "QR detected but it is not a URL."
          );


        }



      } catch(error) {


        setError(
          "Cannot read QR code. Please upload a clear QR image."
        );


      }


    };


  };









  return (

    <div style={styles.container}>


      <input

        ref={fileInputRef}

        type="file"

        accept="image/*"

        onChange={handleImageUpload}

        style={{display:"none"}}

      />





      <button

        onClick={handleUploadButton}

        style={styles.button}

      >

        📂 Upload Your QR Code

      </button>








      {imageUrl && (

        <img

          src={imageUrl}

          alt="Uploaded QR"

          style={styles.qrImage}

        />

      )}









      {error && (

        <p style={styles.error}>

          {error}

        </p>

      )}








      {redirecting && (

        <div style={styles.success}>


          <svg

            width="60"

            height="60"

            fill="none"

            stroke="green"

            strokeWidth="4"

            viewBox="0 0 24 24"

          >

            <path

              strokeLinecap="round"

              strokeLinejoin="round"

              d="M5 13l4 4L19 7"

            />

          </svg>





          <div style={styles.successText}>

            🎉 Success!

          </div>




          <div style={styles.redirectText}>

            Redirecting...

          </div>



        </div>

      )}



    </div>

  );

};


export default UploadQRCode2;
